import Index from 'src/pages/Locations/Index.vue'
import Create from 'src/pages/Locations/Create.vue'
import Edit from 'src/pages/Locations/Edit.vue'

const auth = { requiresAuth: true }

export default [
  {
    path: '/locations',
    name: 'Standorte',
    component: Index,
    meta: auth
  },
  {
    path: '/locations/create',
    name: 'Standort Erstellen',
    component: Create,
    meta: auth
  },
  {
    path: '/locations/:id/edit',
    name: 'Standort Bearbeiten',
    component: Edit,
    meta: auth
  }
]
